webpackJsonp([11643068821409],{

/***/ 335:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(3);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(18);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	__webpack_require__(335);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhiteLabellingPage = function (_React$Component) {
	  _inherits(WhiteLabellingPage, _React$Component);
	
	  function WhiteLabellingPage(props) {
	    _classCallCheck(this, WhiteLabellingPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  WhiteLabellingPage.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  WhiteLabellingPage.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  WhiteLabellingPage.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'white-labelling-page' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'White Label | FirstStep'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Bring your investment app to life' })
	      ),
	      _react2.default.createElement(_Banner2.default, {
	        ctaMode: true,
	        buttonMode: false,
	        contactLink: 'hello@firststep.co',
	        title: 'Bring your investment product to life',
	        tagline: 'For enquiries, please contact'
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'app-screen invest', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row align-items-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'section-left' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    'White label FirstStep and launch'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Our mission is to create a micro-investment solution that helps people reach their goals faster in a simple and engaging way. This mission is delivered through the FirstStep brand and white label partners.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'To pass on low fees to its customers, FirstStep made a bold decision to build its own operating system, one that can seamlessly be integrated with other products.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'FirstStepOS is a proven micro-investing platform that helps build and run an entire managed investment scheme (MIS) whose distinct personalised touch gives you a distinct competitive advantage. '
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 phone' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'section-right text-right' },
	                  _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('images/graphics/app-screens/iphone_sectors.png'), className: 'iphone-img img-fluid w-75', alt: 'Phone screen sectors' })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'container' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'what-get', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-center' },
	              'Adding value for your business'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Lower acquisition costs'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Investing apps have a lower cost of acquisition with greater loyalty'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Engagement with millennials'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Build direct engagement with millennials early in their financial journey'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Bank aggregation and payments'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Data feeds, fast cash transfers and cash reconiliation at scale'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Goals based investing'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Invest with passion and purpose by setting goals and tracking progress'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Unit registry'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Onboard customers at scale with instant verification and ongoing due diligence'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-tick.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Fund administration'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Automated investment management services so you can spend more time with customers'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return WhiteLabellingPage;
	}(_react2.default.Component);
	
	exports.default = WhiteLabellingPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-white-labelling-index-js-6452e801c7f385f96548.js